import { Link } from 'react-router-dom';
import { useHistory } from '@/hooks/useFavorites';
import { getEpisodeById, getDramaById } from '@/lib/content';

export default function RecentHistory() {
  const { history, clearHistory } = useHistory();

  const items = history
    .map((h) => {
      const episode = getEpisodeById(h.id);
      if (!episode) return null;
      const drama = getDramaById(episode.dramaId);
      return { episode, dramaTitle: drama?.title ?? '' };
    })
    .filter((item): item is { episode: NonNullable<ReturnType<typeof getEpisodeById>>; dramaTitle: string } => item !== null)
    .slice(0, 6);

  if (items.length === 0) {
    return (
      <section className="w-full bg-background-100 py-12 md:py-14">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="flex items-center gap-2 mb-5">
            <i className="ri-history-line text-xl text-primary-700"></i>
            <h2 className="text-lg md:text-xl font-bold text-foreground-950">最近浏览</h2>
          </div>
          <div className="rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-10 text-center">
            <span className="mx-auto w-12 h-12 rounded-full bg-background-100 flex items-center justify-center text-foreground-400 mb-3">
              <i className="ri-play-circle-line text-2xl"></i>
            </span>
            <p className="text-sm text-foreground-600">
              还没有浏览记录，播放任意章节后，这里会自动显示你最近看过的剧集。
            </p>
            <Link
              to="/play/nanny-1"
              className="mt-4 inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-play-fill"></i>
              去看第一集
            </Link>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="w-full bg-background-100 py-12 md:py-14">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between gap-4 mb-6">
          <div className="flex items-center gap-2">
            <i className="ri-history-line text-xl text-primary-700"></i>
            <h2 className="text-lg md:text-xl font-bold text-foreground-950">最近浏览</h2>
          </div>
          <button
            type="button"
            onClick={clearHistory}
            className="text-xs text-foreground-500 hover:text-accent-600 transition-colors whitespace-nowrap"
          >
            清除记录
          </button>
        </div>
        <div className="flex gap-4 overflow-x-auto pb-2 no-scrollbar">
          {items.map(({ episode, dramaTitle }) => (
            <Link
              key={episode.id}
              to={`/play/${episode.id}`}
              className="group w-56 shrink-0 rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={episode.thumb}
                  alt={`第${episode.number}集剧照`}
                  title={`迷人的保姆 第${episode.number}集`}
                  className="w-full h-full object-top object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-3">
                <h3 className="text-sm font-medium text-foreground-950 truncate">{episode.title}</h3>
                <p className="text-xs text-foreground-500 mt-1 truncate">
                  {dramaTitle} · 第 {episode.number} 集
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}